<template>
    <div>
        <v-col cols="12">
            <button class="button back-to-list" @click="backToList">
                <v-icon>mdi-arrow-left</v-icon>
                <span class="text">Back To List</span>
            </button>
        </v-col>
        <v-col cols="12">
            <h2>
                {{
                    id
                        ? t('email-templates::page.title.edit_message_template')
                        : t('email-templates::page.title.new_message_template')
                }}
            </h2>
        </v-col>
        <v-col cols="12">
            <div class="form-wrapper">
                <v-form ref="form" v-model="isValid" class="message-template-form">
                    <div>
                        <v-row>
                            <v-col cols="12" lg="6" class="py-0">
                                <v-text-field
                                    v-model="messageTemplate.template_key"
                                    :error-messages="errorMessages.template_key"
                                    :label="'* ' + t('email-templates::details.label.template_key')"
                                    :rules="rules.template_key"
                                    dense
                                    background-color="#fff"
                                    disabled
                                    outlined
                                    readonly
                                    rounded
                                    required
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" lg="6" class="py-0">
                                <div class="d-flex">
                                    <v-col class="py-0">
                                        <v-switch
                                            v-model="messageTemplate.is_active"
                                            :label="t('email-templates::create.label.is_active')"
                                            class="mt-0"
                                        ></v-switch>
                                    </v-col>
                                    <!-- <v-col class="py-0">
                                        <v-switch
                                            v-model="messageTemplate.is_system"
                                            :label="t('email-templates::create.label.is_system')"
                                            class="mt-0"
                                            disabled
                                        ></v-switch>
                                    </v-col> -->
                                </div>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" lg="6" class="pb-0">
                                <v-text-field
                                    v-model="messageTemplate.subject"
                                    :error-messages="errorMessages.subject"
                                    :label="'* ' + t('email-templates::details.label.subject')"
                                    :rules="rules.subject"
                                    dense
                                    background-color="#fff"
                                    outlined
                                    rounded
                                    required
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" lg="6" class="pb-0">
                                <v-text-field
                                    v-model="messageTemplate.mail_from"
                                    :error-messages="errorMessages.mail_from"
                                    :label="'* ' + t('email-templates::details.label.mail_from')"
                                    :rules="rules.mail_from"
                                    dense
                                    background-color="#fff"
                                    outlined
                                    rounded
                                    required
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col :class="{ 'editor-invalid': errorMessages.html_content.length }" cols="12" lg="8">
                                <v-label>* {{ t('email-templates::details.label.html_content') }}</v-label>
                                <editor
                                    v-model="messageTemplate.html_content"
                                    :init="{
                                        height: 300,
                                        header: true,
                                        statusbar: false,
                                        plugins: [
                                            'advlist autolink lists link image charmap print preview anchor',
                                            'searchreplace visualblocks code fullscreen',
                                            'insertdatetime media table paste code preview',
                                        ],
                                        toolbar:
                                            'insert | undo redo | formatselect | bold italic backcolor | \
                                        alignleft aligncenter alignright alignjustify | \
                                        bullist numlist outdent indent | removeformat | variables | preview',
                                        setup: function (editor) {
                                            editor.ui.registry.addSplitButton('variables', {
                                                text: t('email-templates::details.tinymce.variables'),
                                                tooltip: t('email-templates::details.tinymce.insert_variables'),
                                                onAction: function (_) {},
                                                onItemAction: function (api, value) {
                                                    editor.insertContent('{{' + value + '}}');
                                                },
                                                fetch: function (callback) {
                                                    var items = [];
                                                    messageTemplate.variables.forEach(function (variable) {
                                                        items.push({
                                                            type: 'choiceitem',
                                                            text: variable,
                                                            value: variable,
                                                        });
                                                    });
                                                    callback(items);
                                                },
                                            });
                                        },
                                    }"
                                >
                                </editor>
                                <div class="v-text-field__details">
                                    <div class="v-messages theme--light error--text">
                                        <div v-if="errorMessages.html_content.length" class="v-messages__wrapper">
                                            <div
                                                v-for="(errorMessage, index) in errorMessages.html_content"
                                                :key="index"
                                                class="v-messages__message"
                                            >
                                                {{ errorMessage }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </v-col>
                            <v-col cols="12" lg="4">
                                <v-card class="message-card first mt-0 mt-lg-5">
                                    <v-list-item two-line>
                                        <v-list-item-content>
                                            <v-list-item-subtitle class="title">
                                                {{ t('email-templates::details.available_variables') }}
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list dense nav>
                                        <v-list-item v-for="variable in messageTemplate.variables" :key="variable">
                                            <v-list-item-content>
                                                <v-list-item-title>
                                                    <span v-text="`{{ ${variable} }}`"></span>
                                                </v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list>
                                </v-card>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" lg="8" :class="{ 'editor-invalid': errorMessages.html_content.length }">
                                <v-textarea
                                    v-model="messageTemplate.text_content"
                                    :error-messages="errorMessages.text_content"
                                    :label="'* ' + t('email-templates::details.label.text_content')"
                                    :rules="rules.text_content"
                                    height="300"
                                    background-color="#fff"
                                    outlined
                                ></v-textarea>
                            </v-col>
                            <v-col cols="12" lg="4">
                                <v-card class="message-card mt-0 mt-lg-5">
                                    <v-list-item two-line>
                                        <v-list-item-content>
                                            <v-list-item-subtitle class="title">
                                                {{ t('email-templates::details.required_variables') }}
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list dense nav>
                                        <v-list-item
                                            v-for="required_variable in messageTemplate.required_variables"
                                            :key="required_variable"
                                        >
                                            <v-list-item-content>
                                                <v-list-item-title>
                                                    <span v-text="`{{ ${required_variable} }}`"></span>
                                                </v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list>
                                </v-card>
                            </v-col>
                        </v-row>
                    </div>
                    <b-form-actions
                        :id="id"
                        :back-route="$root.route('message-templates.index')"
                        :has-discard-button="false"
                        @discard="discardChanges"
                        @save="saveMessageTemplate"
                    ></b-form-actions>
                </v-form>
            </div>
        </v-col>
    </div>
</template>

<script>
let formSubmitMixin = require(process.env.MIX_APP_ROOT +
    '/bgo/bgo-components/resources/js/mixins/FormSubmit.js').default;
import Editor from '@tinymce/tinymce-vue';

export default {
    name: 'MessageTemplatesGetComponent',
    components: { Editor },
    mixins: [formSubmitMixin],
    props: {
        id: {
            type: String,
            required: true,
        },
        tinymceApiKey: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            isValid: true,
            loading: false,
            messageTemplate: {},
            rules: {
                template_key: [
                    (v) => !!v || t('default::validation.field.required'),
                    (v) => (v && v.length <= 255) || t('email-templates::validation.template_key.max_length'),
                ],
                subject: [
                    (v) => !!v || t('default::validation.field.required'),
                    (v) => (v && v.length <= 255) || t('email-templates::validation.subject.max_length'),
                ],
                mail_from: [(v) => !!v || t('default::validation.field.required')],
                html_content: [
                    (v) => !!v || t('default::validation.field.required'),
                    (v) =>
                        (v && this.messageTemplate.required_variables.every((val) => v.includes(val))) ||
                        t('email-templates::validation.content.missing_required_variables'),
                ],
                text_content: [
                    (v) => !!v || t('default::validation.field.required'),
                    (v) =>
                        (v && this.messageTemplate.required_variables.every((val) => v.includes(val))) ||
                        t('email-templates::validation.content.missing_required_variables'),
                ],
            },
            errorMessages: {
                template_key: [],
                subject: [],
                mail_from: [],
                html_content: [],
                text_content: [],
            },
            messageTemplateFields: [
                'id',
                'template_key',
                'subject',
                'mail_from',
                'is_active',
                'is_system',
                'variables',
                'required_variables',
                'html_content',
                'text_content',
            ],
        };
    },
    watch: {
        'messageTemplate.html_content': function (newValue) {
            this.errorMessages.html_content = [];

            if (!this.messageTemplate.required_variables.every((val) => newValue.includes(val))) {
                this.isValid = false;
                this.errorMessages.html_content = [
                    t('message-templates::validation.content.missing_required_variables'),
                ];
            }
        },
    },
    created() {
        this.loadMessageTemplate();
    },
    methods: {
        backToList() {
            return this.$root.goTo(route('message-templates.index'));
        },
        async saveMessageTemplate() {
            if (this.id) {
                this.submit(
                    route('api.v1.message-templates.update', {
                        message_template: this.id,
                        fields: this.messageTemplateFields.join(),
                    }),
                    this.messageTemplate,
                    'put',
                    () => {
                        this.$root.notify(
                            'info',
                            t('default::notification.success'),
                            t('message-templates::notification.update')
                        );
                        _.delay(() => {
                            this.$root.goTo(route('message-templates.index'));
                        }, 1000);
                    }
                );
            } else {
                this.submit(route('api.v1.message-templates.store'), this.messageTemplate, 'post', () => {
                    this.$root.notify(
                        'info',
                        t('default::notification.success'),
                        t('message-templates::notification.update')
                    );
                    _.delay(() => {
                        this.$root.goTo(route('message-templates.index'));
                    }, 1000);
                });
            }
        },
        discardChanges() {
            this.loadMessageTemplate();
            this.$root.notify('info', t('default::notifications.changes_discarded'));
        },
        loadMessageTemplate() {
            if (!this.id) {
                return;
            }

            axios
                .get(route('api.v1.message-templates.show', this.id), {
                    params: {
                        fields: this.messageTemplateFields.join(),
                    },
                })
                .then((response) => {
                    this.messageTemplate = response.data.data;
                });
        },
    },
};
</script>
<style scoped>
.editor-invalid .tox-tinymce {
    border: 2px solid #ef9a9a !important;
    border-radius: 6px;
}

.message-template-form .v-list-item__title,
.message-template-form .v-list-item__subtitle {
    white-space: normal;
}
</style>
